import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Instagram } from "lucide-react";
import { api } from "@/lib/api";

export function InstagramStrip() {
  const [d, setD] = useState<any>(null);
  const { pathname } = useLocation();
  useEffect(() => { api.get("/instagram").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d?.enabled || !d.posts?.length || pathname.startsWith("/checkout")) return null;
  const handle = (d.handle || "").replace(/^@/, "");
  const profile = handle ? `https://www.instagram.com/${handle}/` : "https://www.instagram.com/";
  return (
    <section className="max-w-[1400px] mx-auto px-5 md:px-12 w-full mt-24" data-testid="instagram-strip">
      <div className="flex items-end justify-between gap-4 mb-6">
        <h2 className="font-display uppercase text-2xl md:text-3xl tracking-[0.04em]" data-testid="instagram-heading">{d.heading}</h2>
        <a href={profile} target="_blank" rel="noreferrer" className="flex items-center gap-2 text-[13px] uppercase tracking-[0.1em] hover:text-[var(--c-primary)] transition-colors" data-testid="instagram-follow-link">
          <Instagram size={16} strokeWidth={1.5} />{handle ? `@${handle}` : "Follow us"}
        </a>
      </div>
      <div className="grid grid-cols-3 md:grid-cols-6 gap-1.5 md:gap-3">
        {d.posts.map((p: any, i: number) => (
          <a key={i} href={p.url || profile} target="_blank" rel="noreferrer" aria-label={p.caption || "Instagram post"} className="group relative aspect-square overflow-hidden bg-neutral-100" data-testid={`instagram-post-${i}`}>
            <img src={p.image} alt={(p.caption || "Somnio.Co on Instagram").slice(0, 120)} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <span className="absolute inset-0 grid place-items-center bg-black/0 group-hover:bg-black/30 transition-colors"><Instagram size={22} className="text-white opacity-0 group-hover:opacity-100 transition-opacity" /></span>
          </a>
        ))}
      </div>
    </section>
  );
}
